import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
export default class extends Controller {
  static values = { feedbackText: String, isRichContent: Boolean };
  static targets = ["source", "button", "feedbackTemplate", "feedbackFlash"];

  async copy(event) {
    const initialHtml = event.currentTarget.outerHTML;

    const html = this.sourceTarget.innerHTML;
    const plain = this.sourceTarget.innerText;

    if (this.isRichContentValue) {
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([plain], { type: "text/plain" }),
        }),
      ]);
    } else {
      navigator.clipboard.writeText(plain.trim());
    }

    if (this.hasButtonTarget) {
      if (this.hasFeedbackTemplateTarget) {
        const content = this.feedbackTemplateTarget.innerHTML;
        this.buttonTarget.classList.add("pointer-events-none");
        this.buttonTarget.innerHTML = content;
      } else {
        this.buttonTarget.innerText = this.feedbackTextValue;
      }
      setTimeout(() => {
        this.buttonTarget.outerHTML = initialHtml;
      }, 2000);
    }
    if (this.hasFeedbackFlashTarget) {
      const clone = this.feedbackFlashTarget.content.cloneNode(true);
      this.element.appendChild(clone);
    }
  }
}
